import { Checkbox, Field } from 'Components/Core';
import { WorksheetBatchUpdateQueryField } from 'Components/WorksheetBatchUpdate';

export const BsNuclearFieldDensityQueryFields: { [name: string]: WorksheetBatchUpdateQueryField } = {
  IsReferenceDensityRequired: {
    entryComponent: <Field input={<Checkbox />} label="Only include tests that require a laboratory density" />,
    // When true, we require reference density. When false, we include all tests (so this property is undefined).
    valueToParam: (value) => (value ? 'true' : undefined),
    paramToValue: (urlParam) => (urlParam.toLowerCase() === 'true' ? true : undefined),
  },
};

export default BsNuclearFieldDensityQueryFields;
